module.exports = __webpack_public_path__ + "img/coming-soon-dark.4f6e631d.svg";